import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getHoneycombRailHexColour } from '../../../../../helpers/getHexColorCode';
import { getPatternImages } from '../../../../../helpers/getPatternImages';
import { getDayColourSwatchUrl } from '../../../../../helpers/getDayColourSwatchUrl';

export const HoneycombDayNight = (props: React.SVGProps<SVGSVGElement>) => {
  const [state] = useService(productBuilderMachine);
  const patternUrl = getPatternImages(state);
  const dayFill = getDayColourSwatchUrl(state);

  // Set a default value for Top for Day if value is empty
  const topPattern =
    typeof state.context.custom.dayFabricPosition === 'undefined' ||
    state.context.custom.dayFabricPosition === 'Top'
      ? dayFill
      : patternUrl;

  // Set default value for Bottom for Night if value is empty
  const bottomPattern =
    state.context.custom.dayFabricPosition === 'Bottom' ? dayFill : patternUrl;

  var lightGuards =
    typeof state.context.custom.lightGuards === 'number' ? 'Yes' : '';

  const railColour = state.context.custom.railColour
    ? state.context.custom.railColour
    : 'White';
  const railColourHex = getHoneycombRailHexColour(railColour);

  if (lightGuards !== 'Yes') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 554.2 420"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="hcDayNight"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={topPattern} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <pattern
            id="hcDayColour"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={bottomPattern} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <path fill="url(#hcDayColour)" d="M5 204.5h544.2v97.3H5z" />
        <path fill="url(#hcDayNight)" d="M5 10h544.2v194.5H5z" />
        <linearGradient
          id="prefix__a"
          gradientUnits="userSpaceOnUse"
          x1={277.1}
          y1={-21.941}
          x2={277.1}
          y2={-40}
          gradientTransform="translate(0 50)"
        >
          <stop offset={0.489} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.3} />
        </linearGradient>
        <path fill="url(#prefix__a)" d="M5 10h544.2v18.1H5z" />
        <g fill={`${railColourHex}`}>
          <path d="M0 0h554.2v10H0zM2.6 299.5h549.1v5H2.6zM2.6 204.5h549.1v5H2.6z" />
        </g>
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 554.2 409"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="hcDayNight"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={topPattern} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <pattern
            id="hcDayColour"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={bottomPattern} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <linearGradient
            id="prefix__a"
            x1={277.1}
            y1={431.94}
            x2={277.1}
            y2={450}
            gradientTransform="matrix(1 0 0 -1 0 460)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.49} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
        </defs>
        <path d="M5 204.5h544.2v97.3H5z" fill="url(#hcDayColour)" />
        <path d="M5 10h544.2v194.5H5z" fill="url(#hcDayNight)" />
        <path
          d="M0 0v409h5V304.5h544.2V409h5V0zm549.2 10v192H5V10zM5 299.5V207h544.2v92.5z"
          fill={railColourHex}
        />
        <path d="M5 10h544.2v18.1H5z" fill="url(#prefix__a)" />
      </svg>
    );
  }
};
